import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const Loss = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2074_7799)">
      <path d="M18.5752 7.23145L23.0283 5.06348L22.9072 10.0156L27.8252 10.5996L25.0459 14.6992L28.8682 17.8496L24.3135 19.7969L25.8252 24.5137L20.9404 23.6885L19.6621 28.4736L16 25.1387L12.3379 28.4736L11.0596 23.6885L6.1748 24.5137L7.68652 19.7969L3.13184 17.8496L6.9541 14.6992L4.1748 10.5996L9.09277 10.0156L8.97168 5.06348L13.4248 7.23145L16 3L18.5752 7.23145ZM16 15.1709L12.6582 12.2471L11.3418 13.7529L14.4805 16.5L11.3418 19.2471L12.6582 20.7529L16 17.8281L19.3418 20.7529L20.6582 19.2471L17.5186 16.5L20.6582 13.7529L19.3418 12.2471L16 15.1709Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2074_7799">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'Loss'
);
